import React from "react";

export default function AppDivider({ spacing = "md", className = "", ...props }) {
  const classes = [
    "ds-divider",
    `ds-divider--spacing-${spacing}`,
    className,
  ]
    .filter(Boolean)
    .join(" ");

  return <hr className={classes} {...props} />;
}
